import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { mergeRefs } from '@wp-g2/utils';
import React from 'react';
import { TabList as ReakitTabList } from 'reakit';
import TabIndicator from './TabIndicator';
import { useTabsContext } from './Tabs.Context';
import * as styles from './Tabs.styles';
var TabListView = styles.TabListView;

function TabList(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'TabList'),
      children = _useContextSystem.children,
      _useContextSystem$lab = _useContextSystem.label,
      label = _useContextSystem$lab === void 0 ? __('Tabs') : _useContextSystem$lab,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "label"]);

  var _useTabsContext = useTabsContext(),
      listRef = _useTabsContext.listRef,
      resizeListener = _useTabsContext.resizeListener,
      tab = _useTabsContext.tab;

  return /*#__PURE__*/React.createElement(ReakitTabList, Object.assign({
    "aria-label": label,
    as: TabListView,
    ref: mergeRefs([forwardedRef, listRef])
  }, tab, otherProps), resizeListener, children, /*#__PURE__*/React.createElement(TabIndicator, null));
}

export default contextConnect(TabList, 'TabList');